import { createCrudSlice } from '@crm/features/crudSliceFactory';

const module = createCrudSlice({
  name: 'crmManagers',
  path: 'managers',
  singleKey: 'manager',
});

export const managersActions = module.actions;
export const managersThunks = module.thunks;
export const managersSelectors = module.selectors;
export default module.reducer;
